import React from 'react';
import BondDirectoryResultsView from './BondDirectoryResultsView';
import BondDirectorySearchView from './BondDirectorySearchView';
import { Image } from '@ui/atoms';
import { useBondDirectoryContext } from '../context/bond-directory-context';
import { cn } from '@ui/atoms/utils/utils';

const BondDirectoryView = () => {
    const { showResults } = useBondDirectoryContext(({ states }) => ({
        showResults: states.showResultsPage,
    }));

    return (
        <section
            className={cn('relative flex flex-col w-full ', {
                'min-h-auto': showResults,
            })}
        >
            <div
                className={cn(
                    'relative px-4 pt-16 pb-6 bg-primary-500 md:py- md:pt-32 md:px-6 xl:px-16 ',
                    {
                        'pt-22 md:pt-32 rounded-bl-xl rounded-br-xl md:rounded-br-none md:rounded-bl-none':
                            showResults,
                        "bg-[url('/images/opportunities/ListingBackground.svg')] w-full bg-cover bg-center": true,
                    }
                )}
            >
                <BondDirectorySearchView />
                {/* {!showResults && (
                    <Image
                        src="/images/homepage/bond-logo-search.svg"
                        className="absolute right-0 top-4 md:hidden"
                        alt="bond-logo-search"
                    />
                )} */}
            </div>
            {showResults && <BondDirectoryResultsView />}
        </section>
    );
};

export default BondDirectoryView;